//SignIn_Auth0.ts =================================================
// Website: https://auth0.com/
// 1) a) Create a new "Single Page Web Application" call it "GIS Website" or whatever

//    b) Set Settings -> "Allowed Callback URLs" to:
//       https:// Your WEBSERVER URL, others, http://localhost:1337 (for VS)
//       Note - The trailing slash should not be entered and its case sensitive.

//    c) Set "Allowed Logout URLs" to https:// Your WEBSERVER URL/YourWebsiteNameTS/, http://localhost:1337 (for VS)
//       Note - The trailing slash is required and its case sensitive.

//    d) Set "Allowed Web Origins" to the same as "Allowed Callback URLs"

//    e) Save Changes

// 2) Authentication->Database->Username-Password-Authentication->Disable sign ups

// 3) Branding->Universal login->Settings: Upload logo and set colors if desired. Save changes.

// 4) Applications->Applications->GIS Website->Settings->Copy "Domain" and "Client ID" into Settings.ts

// 5) a) User Management->Users->Create User->Enter Email and Password
//    b) Edit the "Name" to be more readable and to set the security access level. Example: 7 ! Joe Bloe
//    c) Repeat for each new user
//    d) Have each user verify their new Auth0 login in their email.

import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util from "./Util";

import { createAuth0Client, Auth0Client } from '@auth0/auth0-spa-js';

export let signedIn: boolean = false;
export let email: string = "";
export let userName: string = "";
export let accessLevel: number = 0;

let auth0_client: Auth0Client;
let callback: iCallbacks;

//Sign in.
export function signIn() {
   Util.logMsg("Auth0: logging in.");
   const url: string = Util.getPageURL();

   auth0_client.loginWithPopup({}).then(token => {
      Util.logMsg("Successfully logged in");
      window.location.href = url;
   });
}

//Sign out.
export function signOut() {
   Util.logMsg("Auth0: logging out.");
   signedIn = false;

   auth0_client.logout({
      logoutParams: { returnTo: window.location.href }
   });
}

//Declare the callback function.
interface iCallbacks {
   success(): void;
   fail(): void;
}

//Initialize.
export function authenticate(callbacks: iCallbacks) {
   callback = callbacks;
   Util.logMsg("Auth0: Creating API.");

   createAuth0Client({
      domain: Settings.auth0_domain,
      clientId: Settings.auth0_clientId,

   }).then(auth0Client => {
      auth0_client = auth0Client;
      Util.logMsg("auth0_client", auth0_client);

      //logged in. Get the user profile:
      auth0_client.getUser().then(user => {
         Util.logMsg("Getting Auth0 user information: ", user);

         if (user) {
            signedIn = true;
            email = user.email;
            userName = user.nickname; // Prefix portion of the users email address.
            accessLevel = Util.parseInteger(user.name); //Access level comes from the edited "Name" in Auth0.  Example: 9 ! Joe Bloe
            if (accessLevel === 0) {
               accessLevel = 1; //Default for at least having an auth0 account.
            }
            callback.success();

         } else {
            callback.fail();
         }
      });
   });
}
